export enum LocationStatus {
    // Deleted = -1,
    Disabled = 0,
    Active = 1
  }
  
  (LocationStatus as any).__typeName = 'LocationStatus';
  